export default __webpack_public_path__ + "static/media/006-eye.0df73e21.png";